var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value === true)?_vm._t("true"):(_vm.value === false)?_vm._t("false"):_vm._t("unknown")],2)}
var staticRenderFns = []

export { render, staticRenderFns }